<script setup="">
import { computed, inject } from "vue";

import ActionButton from "@/Components/Modal/ActionButton.vue";

import { useResponsiveStore } from "@/stores/responsive";
import { MenuItem } from "@headlessui/vue";

defineEmits(["mousedown"]);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  classes: {
    type: String,
    default: ""
  }
});

const twMerge = inject("twMerge");
const responsive = useResponsiveStore();

const defaultClass = "relative cursor-pointer whitespace-nowrap bg-white px-4 py-2 text-sm text-700 hover:font-bold hover:bg-200";
const computedClass = computed(() => twMerge(defaultClass, props.classes));
</script>

<template>
  <MenuItem
    v-if="responsive.smAndUp"
    v-slot="slotProps"
    v-bind="$attrs"
    :class="[computedClass, disabled ? 'form-processing' : '']"
    :disabled="disabled"
    as="div"
  >
    <slot v-bind="slotProps" />
  </MenuItem>

  <ActionButton v-else v-slot="slotProps" v-bind="$attrs" :class="{ 'form-processing': disabled }" :disabled="disabled">
    <slot v-bind="slotProps" />
  </ActionButton>
</template>
